import SignUpForm from './SignUpForm';
import Testimony from './Testimony';
import useText from '@/hooks/useText';
import SharedBadge from '@/global/Badge/Badge';

function ApplyTrial() {
  const testimonialsLabel = useText('home.testimonials.label');
  const testimonialsTitle = useText('home.testimonials.title');
  const eyebrow = useText('signup.apply_trial.label');
  const title = useText('signup.apply_trial.title');
  const titleHighlight = useText('signup.apply_trial.title_highlight');
  const titleSuffix = useText('signup.apply_trial.title_suffix');

  return (
    <div className="apply-trial-content">
      <div className="hidden md:block ml-16 mb-8 mt-16 absolute">
        <SharedBadge text={eyebrow} icon={null} variant="primary" size="sm" />
        <h1 className="text-start mx-auto font-semibold text-4xl max-w-3xl">
          {title} <span className="home-hero-highlight">{titleHighlight}</span> {titleSuffix}
        </h1>
      </div>
      <div className="md:grid md:grid-cols-2 md:gap-10 md:items-start">
        <div className="apply-trial-hero-col-height flex items-start justify-start px-4 md:px-0">
          <div className="w-full text-start">
            <div className="w-full flex justify-center mt-0 md:mt-0">
              <SignUpForm />
            </div>
          </div>
        </div>

        <div className="hidden md:flex items-center justify-center md:overflow-hidden apply-trial-hero-col-height">
          <img
            src="/static/images/signup-banner.jpg"
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover object-bottom"
          />
        </div>
      </div>

      <section id="testimonials" className="home-section home-section-dark home-testimonials">
        <div className="text-center">
          <span className="home-section-label text-pink mb-4">{testimonialsLabel}</span>
          <h2 className="home-section-title home-section-title-center home-section-title-light text-white">
            {testimonialsTitle}
          </h2>
        </div>
        <Testimony variant="cards" />
      </section>
    </div>
  );
}

export default ApplyTrial;
